module.exports = __webpack_public_path__ + "img/1701388977357-6d475483-c72e-41f7-9fc1-7f48adc96893.jpeg.0d362230.webp";